import { required } from "@libs/validation/fieldValidators.ts";
import { Validator } from "@libs/validation/Validator.ts";

import { EditBaseIntervalFormValues } from "./EditBaseIntervalModal.tsx";

export class EditBaseIntervalModalValidator extends Validator<EditBaseIntervalFormValues> {
  constructor() {
    super();

    this.forField("readKnowledgeBase", required());
    this.forField("hasPlan", required());
    this.forField("contactedSupport", required());
  }
}
